export default __webpack_public_path__ + "static/media/Path3418.4a4281d5.svg";